module.exports = __webpack_public_path__ + "img/product-2-min.a662b4ef.jpg";